import { cn } from "@/lib/utils";

export interface CountBadgeProps {
  /** Zero e negativo não renderizam: um contador vazio é ruído, não informação. */
  count: number;
  /** Posicionamento e visibilidade — o badge não sabe onde está pendurado. */
  className?: string;
}

/**
 * O contador vermelho sobre um ícone: notificações na campainha, pendências
 * no item do menu.
 *
 * `aria-hidden` de propósito, e não por descuido: a contagem já está no nome
 * acessível do controle que envolve o badge (`Notificações — 3 pendentes`).
 * Lido duas vezes, o leitor de tela anuncia "Notificações 3 pendentes 3".
 * Quem usa este componente precisa garantir esse rótulo no pai.
 *
 * `min-w-5` e não `w-5`: com dois dígitos a pílula cresce na horizontal em vez
 * de espremer o número.
 */
export function CountBadge({ count, className }: CountBadgeProps) {
  if (count <= 0) return null;

  return (
    <span
      aria-hidden
      className={cn(
        "absolute top-1 right-1 flex h-5 min-w-5 items-center justify-center",
        "rounded-pill bg-feedback-danger px-1 text-body-xs font-bold text-on-primary",
        className,
      )}
    >
      {count}
    </span>
  );
}
